import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { createQueryCustomHook } from "../../../../stores/useQueryState";
import { Select } from "../../../../ui/Select/Select";
import { Label } from "../Label/Label";

const all = "all";
export const orderSizeOptions = [50, 150, 200, 500, all];

export const useOrdersSizeParam = createQueryCustomHook("size", () => {
  return (value): number | string => {
    if (value === all) {
      return all;
    }
    const valueAsNumber = Number(value);
    return orderSizeOptions.includes(valueAsNumber)
      ? valueAsNumber
      : orderSizeOptions[0];
  };
});

export const OrdersSizeSelect: FunctionComponent = () => {
  const { t } = useTranslation();
  const [size, setSize] = useOrdersSizeParam();
  return (
    <fieldset>
      <Label htmlFor="size-filter">{t("orderFilters.size")}</Label>
      <Select
        onChange={(event): void => {
          setSize(event.target.value);
        }}
        aria-label="sizeFilter"
        className="w-full"
        id="size-filter"
        value={size}
      >
        {orderSizeOptions.map((option) => (
          <option key={option} value={option}>
            {Number(option) ? option : t(`orderFilters.${option}`)}
          </option>
        ))}
      </Select>
    </fieldset>
  );
};
